import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { OidcClientService } from "@upmc-healthplan-npm/oidc-client";
import { StartNgIdleService } from "../../services/ng-idle-startup/start-ng-idle.service";

@Component({
  selector: "app-ep-timeout",
  templateUrl: "./ep-timeout.component.html",
  styleUrls: ["./ep-timeout.component.scss"],
  standalone: false,
})
export class EpTimeoutComponent implements OnInit {
  active: boolean;
  @Output() closePopup = new EventEmitter();

  constructor(
    private auth: OidcClientService,
    private idleService: StartNgIdleService,
  ) {}

  ngOnInit() {
    this.active = false;
  }

  handleEvent(event) {
    if (event.action === "done") {
      if (this.auth.getUser() && !this.active) {
        sessionStorage.setItem("timeOut", "true");
        this.auth.signOut();
      }
    }
  }

  continue() {
    this.active = true;
    sessionStorage.removeItem("timeOut");
    this.idleService.resetIdleTimer();
    this.closePopup.emit(true);
  }
}
